import React from 'react'
import ClipLoader from 'react-spinners/ClipLoader'

const LoadingComponent = () => {
  return <ClipLoader loading={true} size={150} color={`#222533`} />
}

export default LoadingComponent
